module.exports = __webpack_public_path__ + "static/ModelBW-04bc3f099b482111e3e3591c94ec422b.jpg";